module.exports = __webpack_public_path__ + "static/img/supplychain2.f729ca21.jpg";